module.exports = __webpack_public_path__ + "static/media/senso.49abe1b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/senso.jpg
// module id = 598
// module chunks = 0